module.exports = __webpack_public_path__ + "media/Anaya.3877cac4.mp3";